import { Component, Input } from '@angular/core';

import { BuildingBlockInterface } from '../building-block.interface';
import { LiveProjectComponentContext } from './live-project-context.interface';

@Component({
    templateUrl: './live-project.component.html',
    styleUrls: ['./live-project.component.min.css'],
})
export class LiveProjectComponent implements BuildingBlockInterface {
    @Input() public context: LiveProjectComponentContext;
    public paddingEnabled = false;
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/live-project/live-project.component.ts